import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';

import store from './store';
import { GlobalizationProvider } from '@Translations/GlobalizationProvider';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback="">
        <GlobalizationProvider>
          <App />
        </GlobalizationProvider>
      </Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
